<template>
    <div class="main">
      <p>设置密码</p>
      <mt-field placeholder="请输入密码" type="password" v-model="passwd"></mt-field>
      <span v-if="showPasswordError" class="error">请输入密码！</span>
      <p>再次确认</p>
      <mt-field placeholder="请再次输入密码" type="password" v-model="repeatPasswd"></mt-field>
      <span v-if="showRepeatPasswordError" class="error">请输入密码！</span>
      <span v-if="showError" class="error">两次密码不一致！</span>
      <div class="flex btn-container">
        <mt-button class="flex1 left-btn" @click="skip()">忽略</mt-button>
        <mt-button class="flex1 save-btn" @click="setPwd()">保存密码</mt-button>
      </div>
    </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        refer: this.$route.query.refer || '/',
        code: this.$route.query.code,
        passwd: '',
        repeatPasswd: '',
        showError: false,
        showPasswordError: false,
        showRepeatPasswordError: false,
      }
    },
    methods: {
      skip () {
        this.$router.replace(this.refer);
      },
      setPwd() {
        this.showPasswordError = false;
        this.showRepeatPasswordError = false;
        this.showError = false;
        const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
//        if (!reg.test(this.userName)) { //格式不正确
//          this.showError = true;
//          return;
//        }
        if (!this.passwd.trim()) {
          this.showPasswordError = true;
          return;
        }
        if (!this.repeatPasswd.trim()) {
          this.showRepeatPasswordError = true;
          return;
        }
        if (this.repeatPasswd != this.passwd) {
          this.showError = true;
          return;
        }
        let refer = this.refer;
        this.$store.dispatch('user/setPassword', { passwd: this.passwd, refer:refer,code: this.code })
      }
    }
  }
</script>
<style lang="scss"  scoped>
  @import "../../assets/scss/login.scss";
  $mainColor: #009688;
  .btn-container {
    margin-top: 20px;
    .left-btn {
      background-color: #fff;
      color: $mainColor;
      margin-right: 15px;
    }
    .save-btn {
      background-color: $mainColor;
      color: #fff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/loginComponents/SetPassword.vue